import React from 'react';
import { IconType } from 'react-icons';
import { twMerge } from 'tailwind-merge';

/**
 * Compact KPI tile: label + large figure + light-blue icon square.
 * Used on Overview (Members / Verafied / Attendance / Messages).
 */
export default function KpiCard({
  label,
  value,
  icon: Icon,
  className,
  suffix,
}: {
  label: string;
  value: string | number;
  icon: IconType;
  className?: string;
  suffix?: string;
}): JSX.Element {
  return (
    <div
      className={twMerge(
        'relative flex min-h-[110px] flex-1 flex-col justify-between rounded-[12px] bg-secondary-200/70 p-4',
        className,
      )}>
      <p className="text-sm font-medium text-primary-900">{label}</p>
      <div className="flex items-end justify-between gap-2">
        <p className="text-4xl font-semibold leading-none text-primary-900">
          {value}
          {suffix && <span className="text-2xl">{suffix}</span>}
        </p>
        <div className="flex h-9 w-9 items-center justify-center rounded-[8px] bg-primary-100 text-primary-900">
          <Icon size={18} className="flex-shrink-0" />
        </div>
      </div>
    </div>
  );
}
